/* eslint-disable camelcase */
import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';
import { dataPropTypes, fieldsPropTypes, errorsPropTypes } from './propTypes';
import { tableHooks, TableControls } from '../../../../../basicEditor/tableControls';
import TabelRowCell from '../../../../../newEditor/tablePart/tabkeRowCell';
import CalcArea from '../../calcArea';

// import { faCalculator, faFileZipper } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function TRow({
  rowIndex,
  onChange,
  row,
  fields,
  errors,
  highlights,
  readOnly,
  readOnlyFields,
}) {
  const gas_equpmanet = tableHooks.useSelectorInputProps('gas_equpmanet', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);
  const amount = tableHooks.useNumberInputProps('amount', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);
  const length_smoke_tube = tableHooks.useNumberInputProps('length_smoke_tube', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);
  const turns_smoke_tube = tableHooks.useSelectorInputProps('turns_smoke_tube', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);
  const connect_tube = tableHooks.useSelectorInputProps('connect_tube', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);
  const area_connect_tube = tableHooks.useStringInputProps('area_connect_tube', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);

  const [keyParam, setKeyParam] = useState('');

  const [paramVent, setParamVent] = useState({
    isDim: false,
    isDiam: false,
    diam: 0,
    x: 0,
    y: 0,
    note: area_connect_tube.value,

  });

  const setArea = useCallback((e, value) => {
    area_connect_tube.onChange(e, value);
  }, [area_connect_tube]);

  return (
    <Row className="px-1 d-flex">
      <Col xl={3} lg={3}>
        <TabelRowCell
          column="gas_equpmanet"
          highlighted={highlights.includes('gas_equpmanet')}
        >
          <TableControls.SelectorInput {...gas_equpmanet} />
        </TabelRowCell>
      </Col>

      <Col xl={1} lg={1} className="px-1">
        <TabelRowCell
          column="amount"
          highlighted={highlights.includes('amount')}
        >
          <TableControls.NumberInput
            {...amount}
            precision={1}
          />
        </TabelRowCell>
      </Col>

      <Col xl={3} lg={3} className="px-1">
        <TabelRowCell
          column="connect_tube"
          highlighted={highlights.includes('connect_tube')}
        >
          <TableControls.SelectorInput
            {...connect_tube}
          />
        </TabelRowCell>
      </Col>

      {keyParam && (
      <CalcArea
        keyParam={keyParam}
        setKeyParam={setKeyParam}
        paramArea={paramVent}
        setParamVent={setParamVent}
        setArea={setArea}
      />
      )}

      <Col xl={2} lg={2} className="px-1">
        <TabelRowCell
          column="area_connect_tube"
          highlighted={highlights.includes('area_connect_tube')}
        >
          <TableControls.StringInput
            {...area_connect_tube}
            append={(
              <Button
                variant="falcon-info"
                size="sm"
                onClick={() => setKeyParam('area_connect_tube')}
              >
                <FontAwesomeIcon
                  icon={faCalculator}
                />
              </Button>
              )}
            precision={0}
          />
        </TabelRowCell>
      </Col>

      <Col xl={2} lg={2} className="px-1">
        <TabelRowCell
          column="length_smoke_tube"
          highlighted={highlights.includes('length_smoke_tube')}
        >
          <TableControls.NumberInput
            {...length_smoke_tube}
            precision={1}
          />
        </TabelRowCell>
      </Col>

      <Col className="px-1">
        <TabelRowCell
          column="turns_smoke_tube"
          highlighted={highlights.includes('turns_smoke_tube')}
        >
          <TableControls.SelectorInput
            {...turns_smoke_tube}
          />
        </TabelRowCell>
      </Col>

    </Row>
  );
}

TRow.propTypes = {
  rowIndex: PropTypes.number.isRequired,
  row: PropTypes.shape(dataPropTypes).isRequired,
  errors: errorsPropTypes,
  onChange: PropTypes.func.isRequired,
  readOnlyFields: PropTypes.arrayOf(PropTypes.string),
  readOnly: PropTypes.bool,
  fields: fieldsPropTypes.isRequired,
  activeCol: PropTypes.string,
  highlights: PropTypes.arrayOf(PropTypes.string),
  onToggleHighlight: PropTypes.func.isRequired,

};

TRow.defaultProps = {
  errors: null,
  readOnlyFields: [],
  readOnly: false,
  activeCol: null,
  highlights: [],
};

export default memo(TRow);
